import {DimensionValue, StyleSheet} from 'react-native';

import {TAB_BAR_HEIGH} from '/component/layout/TabLayout/TabLayout.style';
import {MAX_CONTENT_WIDTH} from '/constant/data.constant';
import {indent} from '/constant/layout.constant';
import {cloudLightest, white} from '/theme/color/on.color';

const VIEWPORT_HEIGHT_WITHOUT_TAB_BAR: DimensionValue =
  `calc(100vh - ${TAB_BAR_HEIGH}px)` as DimensionValue;

export const styles = StyleSheet.create({
  base: {
    width: '100%' as const,
    maxWidth: MAX_CONTENT_WIDTH as number,
    alignSelf: 'center' as const,
    backgroundColor: white,
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 0,
    height: '100%' as const,
    maxHeight: '100%' as const,
    overflow: 'hidden' as const,
  },
  scrollView: {
    flex: 1,
    minHeight: 0,
    height: '100%' as const,
    maxHeight: VIEWPORT_HEIGHT_WITHOUT_TAB_BAR,
    overflow: 'scroll' as const,
  },
  content: {
    paddingTop: indent * 2.275,
    maxWidth: '100%' as const,
    flexGrow: 1,
    minHeight: '100%',
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: indent * 2.4,
    paddingBottom: indent * 2.4,
    backgroundColor: cloudLightest,
    maxWidth: '100%' as const,
    overflow: 'hidden' as const,
  },
  logo: {
    height: 105,
    width: 112,
  },
});
